import { FormikEntityActionTypeField } from '../FormikEntityActionTypeField'

import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from './FormikEntityActionConfigFields.constants'

function FormikEntityActionConfigFields({ children, typeSelectProps }) {
  return (
    <>
      <FormikEntityActionTypeField
        {...typeSelectProps}
        name={FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME}
      />
      {children}
    </>
  )
}

export default FormikEntityActionConfigFields
